import { render, staticRenderFns } from "./ProjectAddComponentModal.vue?vue&type=template&id=20782a7c&scoped=true&"
import script from "./ProjectAddComponentModal.vue?vue&type=script&lang=js&"
export * from "./ProjectAddComponentModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAddComponentModal.vue?vue&type=style&index=0&id=20782a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20782a7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20782a7c')) {
      api.createRecord('20782a7c', component.options)
    } else {
      api.reload('20782a7c', component.options)
    }
    module.hot.accept("./ProjectAddComponentModal.vue?vue&type=template&id=20782a7c&scoped=true&", function () {
      api.rerender('20782a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectAddComponentModal.vue"
export default component.exports